export { getPageElement };
import React from 'react';
import { PageContextProvider } from '../hooks/usePageContext.js';
function getPageElement(pageContext) {
    const Layout = pageContext.config.Layout ?? PassThrough;
    const Wrapper = pageContext.config.Wrapper ?? PassThrough;
    const VikeReactQueryWrapper = pageContext.config.VikeReactQueryWrapper ?? PassThrough;
    const { Page } = pageContext;
    let page = (React.createElement(PageContextProvider, { pageContext: pageContext },
        React.createElement(VikeReactQueryWrapper, { pageContext: pageContext },
            React.createElement(Wrapper, null,
                React.createElement(Layout, null, Page ? React.createElement(Page, null) : null)))));
    if (pageContext.config.reactStrictMode !== false) {
        page = React.createElement(React.StrictMode, null, page);
    }
    return page;
}
function PassThrough({ children }) {
    return React.createElement(React.Fragment, null, children);
}
